import { RessortEntry } from '../../helper/interfaces'
import React from 'react'
import { nextBasicAuthCheck } from '../../helper/basicAuthHelper'
import { NoContent } from '../../components/shared/NoContent'
import { loadRessort } from '../../helper/externalApi'
import TrackedRessortComponent from '../../components/TrackedRessortComponent'

interface Data {
  entry: RessortEntry | null
  id: string
}

function Index(data: Data) {
  return (
    (data && data.entry && data.entry.status == 200) ?
      <TrackedRessortComponent entry={data.entry} id={data.id} />
      :
      <NoContent status={data.entry?.status.toString()} />
  )
}

export async function getServerSideProps(context) {
  const { req, res } = context
  await nextBasicAuthCheck(req, res)

  const { id } = context.query;
  let ressortId = id

  if(ressortId?.length > 2 && ressortId[1] != ".") {
    const splitId = ressortId.split(".")
    const splitLen = splitId.length
    ressortId = `${splitId[splitLen-2]}.${splitId[splitLen-1]}`
  }
  
  let result: RessortEntry | null = await loadRessort(ressortId);
  return { props: { entry: result, id: ressortId } };
}

export default Index
